





























































































































































































































































































































































































































































































import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import { Inject } from 'inversify-props'
import SeletorDeGruposEconomicos from '@/components/loja/SeletorDeGruposEconomicos.vue'
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'
import BuscaDeProduto from '@/components/produto/BuscaDeProduto.vue'
import { GrupoEconomico } from '@/models/GrupoEconomico'
import { FormEtiquetaDePreco, TamanhoDaEtiqueta } from '@/models/EtiquetaDePreco'
import { Fornecedor } from '@/models/Fornecedor'
import { Loja } from '@/models/Loja'
import { ProdutoFilho } from '@/models/Produto'
import { CampoDeEtiqueta, CampoDeEtiquetaDisponivel, CampoDoModeloDeEtiqueta, CAMPOS_QUE_DEPENDEM_DE_TABELA_DE_PRECO, EntradaDeImpressaoDeModeloDeEtiqueta, ModeloDeEtiqueta, TipoDeAlinhamentoDeTexto, montarTextoDePrecoDaTabela } from '@/models/ModeloDeEtiqueta'
import { TabelaDePreco } from '@/models/TabelaDePrecos'
import { displayNomeCompletoDoProduto } from '@/shareds/produto-shareds'
import { isVestcasa } from '@/shareds/utils'
import { maiorOuIgualAZero, maiorQueZero, obrigatorio } from '@/shareds/regras-de-form'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import AppStore from '@/store/vuex/aplicacao/AppStore'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { EstacaoDeImpressaoUseCase, FindLojaUseCase, ModeloDeEtiquetaUseCase, type EtiquetaDePrecoServiceAdapter } from '@/usecases'
import { EstacaoDeImpressao, extensaoDeArquivoDaLinguagem, FatiaDeImpressaoDeEtiquetas, HistoricoDeEmissaoDeEtiqueta } from '@/models/EstacaoDeImpressao'
import SeletorDeFornecedor from '../fornecedor/SeletorDeFornecedor.vue'
import DialogoDeHistoricoDeImpressaoNaFila from './DialogoDeHistoricoDeImpressaoNaFila.vue'
import DialogoDeHistoricoDeEmissaoDeEtiqueta from './DialogoDeHistoricoDeEmissaoDeEtiqueta.vue'
import DialogoDeEdicaoModeloDeEtiqueta from './DialogoDeEdicaoModeloDeEtiqueta.vue'
import SeletorDeTabelasDePrecoComParcelas from './SeletorDeTabelasDePrecoComParcelas.vue'

const CAMPOS_DE_ETIQUETA = 'CAMPOS_DE_ETIQUETA'
const ITENS_BIPADOS_MODELO = 'ITENS_BIPADOS_MODELO_DE_ETIQUETA'

const EXEMPLO_NOME_DA_TABELA = 'CARTAO CREDITO PARCELADO'
const EXEMPLO_LIMITACAO = '- Limitação 999'

interface Retangulo {
	w: number
	h: number
}

interface GradeDeEtiquetas {
	cols: number
	rows: number
	gapX: number
	gapY: number
	marginX: number
	marginY: number
}

interface DimensaoComGrade {
	bobina: Retangulo
	w: number
	h: number
	gap: number
	marginX: number
	marginY: number
}

interface EstiloCss extends Record<string, string> {}

interface Thumb {
	cells: { style: EstiloCss }[]
	boxStyle: EstiloCss
}

interface ElementoPreview {
	isBarcode: boolean
	wrapStyle: EstiloCss
	barcodeStyle?: EstiloCss
	contentStyle?: EstiloCss
	content?: string
}

interface Preview {
	els: ElementoPreview[]
	boxStyle: EstiloCss
}

interface ModeloView {
	id: string
	nome: string
	grupoEconomico: string
	dimensoes: string
	tamanhoNome: string
	tamanhoThumb: Thumb
	preview: Preview
	bigPreview: Preview
	original: ModeloDeEtiqueta
}

interface ModalTamanhoDraft {
	id: string | null
	nome: string
	grupoEconomico?: string
	bobinaW: number
	bobinaH: number
	labelW: number
	labelH: number
	gap: number
	marginX: number
	marginY: number
	impressaoUnica: boolean
}

@Component({
	components: {
		SeletorDeGruposEconomicos,
		SeletorDeLojasDoUsuario,
		BuscaDeProduto,
		SeletorDeFornecedor,
		DialogoDeEdicaoModeloDeEtiqueta,
		SeletorDeTabelasDePrecoComParcelas,
		DialogoDeHistoricoDeImpressaoNaFila,
		DialogoDeHistoricoDeEmissaoDeEtiqueta,
	},
})
export default class TelaDeCadastroModeloDeEtiqueta extends Vue {
	@Ref() dialogoDeEdicaoModeloDeEtiqueta!: DialogoDeEdicaoModeloDeEtiqueta
	@Ref() dialogoDeHistoricoDeImpressao!: DialogoDeHistoricoDeImpressaoNaFila
	@Ref() dialogoDeHistoricoDeEmissao!: DialogoDeHistoricoDeEmissaoDeEtiqueta
	@Ref() campoDeBuscaDoProduto!: BuscaDeProduto
	@Ref() formTamanho!: HTMLFormElement
	primary = '#6A1B9A'
	PAGE_SIZE = 3

	obrigatorio = obrigatorio
	maiorQueZero = maiorQueZero
	maiorOuIgualAZero = maiorOuIgualAZero

	openPanel: number | undefined = undefined

	filtroTamanhoGrupo: GrupoEconomico | null = null
	filtroTamanhoNome = ''
	filtroModeloGrupo: GrupoEconomico | null = null
	filtroModeloNome = ''
	tamanhosPage = 1
	modelosPage = 1

	modeloSelecionadoId: string | null = (() => {
		try {
			const salvo = JSON.parse(localStorage.getItem(CAMPOS_DE_ETIQUETA) || '{}')
			return salvo.modeloSelecionadoId || null
		} catch { return null }
	})()

	modalTamanhoOpen = false
	modalTamanho: ModalTamanhoDraft | null = null

	tamanhos: TamanhoDaEtiqueta[] = []
	tamanhosTotalPaginas = 1
	tamanhosTotalElements = 0
	carregandoTamanhos = false
	salvandoTamanho = false
	tamanhoEmEdicao: TamanhoDaEtiqueta | null = null
	timerBuscaTamanho: number | undefined = undefined

	modelosApi: ModeloDeEtiqueta[] = []
	modelosTotalPaginasApi = 1
	modelosTotalElements = 0
	carregandoModelos = false
	camposDisponiveis: CampoDeEtiquetaDisponivel[] = []
	timerBuscaModelo: number | undefined = undefined

	@Inject('EtiquetaDePrecoServiceAdapter')
	private etiquetaDePrecoService!: EtiquetaDePrecoServiceAdapter

	modeloDeEtiquetaUseCase = new ModeloDeEtiquetaUseCase()
	estacaoDeImpressaoUseCase = new EstacaoDeImpressaoUseCase()

	estacoesDaLoja: EstacaoDeImpressao[] = []
	estacaoSelecionadaId: string | null = null
	carregandoEstacoes = false
	falhouAoCarregarEstacoes = false

	tipoFiltro: 'produto' | 'nota' = (() => {
		try {
			const salvo = JSON.parse(localStorage.getItem(CAMPOS_DE_ETIQUETA) || '{}')
			return salvo.tipoFiltro === 'nota' ? 'nota' : 'produto'
		} catch { return 'produto' }
	})()
	loja: Loja | null = (() => {
		try {
			const salvo = JSON.parse(localStorage.getItem(CAMPOS_DE_ETIQUETA) || '{}')
			return salvo.loja || null
		} catch { return null }
	})()
	findLojaUseCase = new FindLojaUseCase()
	inicializado = false
	quantidade: number | '' | null = 1
	produtoSelecionado: ProdutoFilho | null = null
	busca: string | null = null
	vestcasa = isVestcasa
	displayNomeCompletoDoProduto = displayNomeCompletoDoProduto

	fornecedor: Fornecedor | null = null
	filtrosNota: { numeroNota: string; serie: string } = { numeroNota: '', serie: '' }
	notasBuscadas = false
	carregandoProdutosNota = false

	itensBipados: FormEtiquetaDePreco[] = (() => {
		try { return JSON.parse(localStorage.getItem(ITENS_BIPADOS_MODELO) || '{}').itensBipados || [] } catch { return [] }
	})()
	produtosBipados: Record<string, ProdutoFilho> = (() => {
		try { return JSON.parse(localStorage.getItem(ITENS_BIPADOS_MODELO) || '{}').produtosBipados || {} } catch { return {} }
	})()
	carregandoPreviaPdf = false
	imprimindo = false
	baixandoArquivo = false
	tabelasSelecionadas: TabelaDePreco[] = []
	parcelasPorTabela: Record<string, number> = (() => {
		try { return JSON.parse(localStorage.getItem(CAMPOS_DE_ETIQUETA) || '{}').parcelasPorTabela || {} } catch { return {} }
	})()

	PONTOS_POR_CM = 28.35

	get chipBg() {
		return '#F3E5F5'
	}

	get modoNoturno() {
		return AppStore.modoNoturno
	}

	get podeEditarTamanhoDeEtiqueta() {
		return UserLoginStore.permiteRegraDeNegocio('pode-editar-criar-tamanho-de-etiqueta')
	}

	get podeVisualizarTamanhosDeEtiqueta() {
		return this.podeEditarTamanhoDeEtiqueta || UserLoginStore.permiteRegraDeNegocio('permite-visualizar-tamanhos-de-etiqueta')
	}

	get podeEditarModeloDeEtiqueta() {
		return UserLoginStore.permiteRegraDeNegocio('pode-editar-criar-modelo-de-etiqueta')
	}

	get corTextoSecundario() {
		return this.modoNoturno ? '#BDBDBD' : '#9E9E9E'
	}

	get buscaUnica() {
		return this.vestcasa
	}

	get totalQuantidade() {
		return this.itensBipados.reduce((sum, it) => sum + (Number(it.quantidade) || 0), 0)
	}

	get tamanhosFiltrados() {
		return this.tamanhos.map(t => {
			const bobina = { w: Number(t.larguraPagina) || 0, h: Number(t.alturaPagina) || 0 }
			const label = { w: Number(t.larguraEtiqueta) || 0, h: Number(t.alturaEtiqueta) || 0 }
			const grade: DimensaoComGrade = {
				bobina, w: label.w, h: label.h,
				gap: Number(t.distanciaEntreEtiquetas) || 0,
				marginX: Number(t.bordaEsquerda) || 0,
				marginY: Number(t.bordaDoTopo) || 0,
			}
			const cols = t.impressaoUnica ? 1 : this.computeCols(grade)
			const rows = t.impressaoUnica ? 1 : this.computeRows(grade)
			const paginaValida = !t.impressaoUnica && bobina.w > 0 && bobina.h > 0
			const pagina = paginaValida ? bobina : { w: label.w || 1, h: label.h || 1 }
			const thumb = this.buildThumb(pagina, label, {
				cols, rows, gapX: grade.gap, gapY: grade.gap,
				marginX: paginaValida ? grade.marginX : 0, marginY: paginaValida ? grade.marginY : 0,
			}, 44, 58)
			return {
				id: t.id,
				nome: t.descricao,
				grupoEconomico: t.grupoEconomico ? t.grupoEconomico.descricao : '—',
				dimensoes: label.w + ' × ' + label.h + ' cm',
				layout: cols + ' col × ' + rows + ' lin',
				thumb,
				original: t,
			}
		})
	}

	get modelosTotalPaginas() {
		return Math.max(1, this.modelosTotalPaginasApi)
	}

	get modelosFiltrados(): ModeloView[] {
		return this.modelosApi.map(m => this.montarModeloView(m))
	}

	get modeloSelecionadoLabel() {
		const sel = this.modelosApi.find(m => m.id === this.modeloSelecionadoId)
		if (!sel) return ''
		const t = sel.tamanho
		const dims = t ? ' (' + (Number(t.larguraEtiqueta) || 0) + '×' + (Number(t.alturaEtiqueta) || 0) + ' cm)' : ''
		return sel.descricao + dims
	}

	get modeloSelecionado(): ModeloDeEtiqueta | null {
		return this.modelosApi.find(m => m.id === this.modeloSelecionadoId) || null
	}

	get modeloRequerTabelaDePreco(): boolean {
		const modelo = this.modeloSelecionado
		if (!modelo) return false
		return modelo.campos.some(campo => campo.campo && CAMPOS_QUE_DEPENDEM_DE_TABELA_DE_PRECO.includes(campo.campo))
	}

	get tabelasDaLoja(): TabelaDePreco[] {
		const listas = this.loja?.configuracaoDaLoja?.tabelasDePreco || []
		return listas.map(l => l.tabelaDePreco)
	}

	get modalCols() {
		if (!this.modalTamanho) return 1
		return this.computeCols(this.modalDraft)
	}
	get modalRows() {
		if (!this.modalTamanho) return 1
		return this.computeRows(this.modalDraft)
	}
	get modalDraft(): DimensaoComGrade {
		const d = this.modalTamanho
		if (!d) return { bobina: { w: 0, h: 0 }, w: 0, h: 0, gap: 0, marginX: 0, marginY: 0 }
		return {
			bobina: { w: Number(d.bobinaW) || 0, h: Number(d.bobinaH) || 0 },
			w: Number(d.labelW) || 0, h: Number(d.labelH) || 0, gap: Number(d.gap) || 0,
			marginX: Number(d.marginX) || 0, marginY: Number(d.marginY) || 0,
		}
	}
	get modalThumb() {
		const d = this.modalDraft
		const label = { w: d.w, h: d.h }
		const impressaoUnica = !!(this.modalTamanho && this.modalTamanho.impressaoUnica)
		const paginaValida = !impressaoUnica && d.bobina.w > 0 && d.bobina.h > 0
		const pagina = paginaValida ? d.bobina : { w: label.w || 1, h: label.h || 1 }
		return this.buildThumb(pagina, label, {
			cols: this.modalCols, rows: this.modalRows, gapX: d.gap, gapY: d.gap,
			marginX: paginaValida ? d.marginX : 0, marginY: paginaValida ? d.marginY : 0,
		}, 420, 440)
	}

	computeCols(t: DimensaoComGrade) { return Math.max(1, Math.floor((t.bobina.w - t.marginX + t.gap) / (t.w + t.gap)) || 1) }
	computeRows(t: DimensaoComGrade) { return Math.max(1, Math.floor((t.bobina.h - t.marginY + t.gap) / (t.h + t.gap)) || 1) }

	get modalTamanhoValido(): boolean {
		const d = this.modalTamanho
		if (!d) return false
		if (!d.nome || !d.nome.trim()) return false
		if (!d.impressaoUnica && (!(Number(d.bobinaW) > 0) || !(Number(d.bobinaH) > 0))) return false
		if (!(Number(d.labelW) > 0) || !(Number(d.labelH) > 0)) return false
		if (d.gap === null || d.gap === undefined || Number(d.gap) < 0) return false
		if (d.marginY === null || d.marginY === undefined || Number(d.marginY) < 0) return false
		if (d.marginX === null || d.marginX === undefined || Number(d.marginX) < 0) return false
		return true
	}

	get modalTamanhoCabeNaPagina(): boolean {
		const d = this.modalTamanho
		if (!d) return true
		if (d.impressaoUnica) return true
		return (Number(d.labelW) || 0) + (Number(d.marginX) || 0) <= (Number(d.bobinaW) || 0)
			&& (Number(d.labelH) || 0) + 2 * (Number(d.marginY) || 0) <= (Number(d.bobinaH) || 0)
	}

	async created() {
		this.openPanel = this.podeVisualizarTamanhosDeEtiqueta ? 1 : 0

		if (this.podeVisualizarTamanhosDeEtiqueta) this.buscarTamanhos()
		this.carregarCamposDisponiveis()
		this.buscarModelos()

		if (this.loja && typeof this.loja === 'string') {
			try {
				this.loja = await this.findLojaUseCase.findLojaById(this.loja as unknown as string)
			} catch { /* mantém como está */ }
		}

		try {
			const salvo = JSON.parse(localStorage.getItem(CAMPOS_DE_ETIQUETA) || '{}')
			if (Array.isArray(salvo.tabelasSelecionadasIds) && salvo.tabelasSelecionadasIds.length > 0) {
				this.tabelasSelecionadas = this.tabelasDaLoja.filter(t => salvo.tabelasSelecionadasIds.includes(t.id))
			}
		} catch { /* ignore */ }

		this.inicializado = true
	}

	@Watch('loja')
	@Watch('tipoFiltro')
	@Watch('modeloSelecionadoId')
	@Watch('tabelasSelecionadas', { deep: true })
	@Watch('parcelasPorTabela', { deep: true })
	onChangeCamposDeEtiqueta() {
		if (!this.inicializado) return
		localStorage.setItem(CAMPOS_DE_ETIQUETA, JSON.stringify({
			loja: this.loja,
			tipoFiltro: this.tipoFiltro,
			modeloSelecionadoId: this.modeloSelecionadoId,
			tabelasSelecionadasIds: this.tabelasSelecionadas.map(t => t.id),
			parcelasPorTabela: this.parcelasPorTabela,
		}))
	}

	@Watch('loja')
	@Watch('modeloSelecionadoId')
	onChangeLojaOuModeloLimpaTabelaSelecionada() {
		if (!this.inicializado) return
		this.tabelasSelecionadas = []
	}

	// A estação é por loja, então trocar de loja invalida a escolha anterior. Immediate para a lista
	// já vir carregada quando a loja veio restaurada do localStorage.
	@Watch('loja', { immediate: true })
	async carregarEstacoesDaLoja() {
		const lojaId = typeof this.loja === 'string' ? this.loja : this.loja?.id
		if (!lojaId) {
			this.estacoesDaLoja = []
			this.estacaoSelecionadaId = null
			return
		}

		try {
			this.carregandoEstacoes = true
			this.falhouAoCarregarEstacoes = false
			// Só ativas: estação inativa existe no cadastro justamente para não ser oferecida aqui.
			this.estacoesDaLoja = await this.estacaoDeImpressaoUseCase.findEstacoesDeImpressaoPorLoja(lojaId, true)
			this.resolverEstacaoSelecionada()
		} catch (error: any) {
			// Sem alerta aqui: a tela imprime hoje pelo fluxo de PDF, e falhar ao listar estação não
			// pode virar erro em cima de quem nem usa impressão direta. A falha é lembrada para o
			// clique em Imprimir dar a mensagem certa em vez de acusar falta de cadastro.
			this.estacoesDaLoja = []
			this.estacaoSelecionadaId = null
			this.falhouAoCarregarEstacoes = true
		} finally {
			this.carregandoEstacoes = false
		}
	}

	// Com uma estação só — o caso padrão — não há o que escolher: seleciona sozinha e o seletor nem
	// aparece. Com mais de uma, exige escolha explícita em vez de chutar a primeira, porque imprimir
	// na impressora errada é papel perdido no lugar errado da loja.
	private resolverEstacaoSelecionada() {
		if (this.estacoesDaLoja.length === 1) {
			this.estacaoSelecionadaId = this.estacoesDaLoja[0].id
			return
		}
		const aindaExiste = this.estacoesDaLoja.some(estacao => estacao.id === this.estacaoSelecionadaId)
		if (!aindaExiste) {
			this.estacaoSelecionadaId = null
		}
	}

	get precisaEscolherEstacao() {
		return this.estacoesDaLoja.length > 1
	}

	get estacaoSelecionada(): EstacaoDeImpressao | null {
		return this.estacoesDaLoja.find(estacao => estacao.id === this.estacaoSelecionadaId) || null
	}

	async carregarCamposDisponiveis() {
		if (this.camposDisponiveis.length > 0) return
		try {
			this.camposDisponiveis = await this.modeloDeEtiquetaUseCase.listarCamposDisponiveis()
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	async buscarTamanhos() {
		try {
			this.carregandoTamanhos = true
			const pagina = await this.etiquetaDePrecoService.findTamanhoDeEtiqueta({
				busca: this.filtroTamanhoNome ? this.filtroTamanhoNome.trim() : undefined,
				grupoEconomicoId: this.filtroTamanhoGrupo ? this.filtroTamanhoGrupo.id : undefined,
				page: this.tamanhosPage - 1,
				size: this.PAGE_SIZE,
			})
			this.tamanhos = pagina.content
			this.tamanhosTotalPaginas = Math.max(1, pagina.totalPages || 1)
			this.tamanhosTotalElements = pagina.totalElements || pagina.content.length
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregandoTamanhos = false
		}
	}

	reiniciarTamanhos() {
		this.tamanhosPage = 1
		this.buscarTamanhos()
	}

	irParaPaginaTamanho(delta: number) {
		const alvo = this.tamanhosPage + delta
		if (alvo < 1 || alvo > this.tamanhosTotalPaginas) return
		this.tamanhosPage = alvo
		this.buscarTamanhos()
	}

	onBuscaNomeTamanho() {
		window.clearTimeout(this.timerBuscaTamanho)
		this.timerBuscaTamanho = window.setTimeout(() => this.reiniciarTamanhos(), 400)
	}

	@Watch('filtroTamanhoGrupo')
	onFiltroGrupoTamanho() {
		this.reiniciarTamanhos()
	}

	async buscarModelos() {
		try {
			this.carregandoModelos = true
			const pagina = await this.modeloDeEtiquetaUseCase.findModeloDeEtiqueta({
				busca: this.filtroModeloNome ? this.filtroModeloNome.trim() : undefined,
				grupoEconomicoId: this.filtroModeloGrupo ? this.filtroModeloGrupo.id : undefined,
				page: this.modelosPage - 1,
				size: this.PAGE_SIZE,
			})
			this.modelosApi = pagina.content
			this.modelosTotalPaginasApi = Math.max(1, pagina.totalPages || 1)
			this.modelosTotalElements = pagina.totalElements || pagina.content.length
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregandoModelos = false
		}
	}

	reiniciarModelos() {
		this.modelosPage = 1
		this.buscarModelos()
	}

	irParaPaginaModelo(delta: number) {
		const alvo = this.modelosPage + delta
		if (alvo < 1 || alvo > this.modelosTotalPaginas) return
		this.modelosPage = alvo
		this.buscarModelos()
	}

	onBuscaNomeModelo() {
		window.clearTimeout(this.timerBuscaModelo)
		this.timerBuscaModelo = window.setTimeout(() => this.reiniciarModelos(), 400)
	}

	@Watch('filtroModeloGrupo')
	onFiltroGrupoModelo() {
		this.reiniciarModelos()
	}

	buildThumb(page: Retangulo, label: Retangulo, grid: GradeDeEtiquetas, boxW: number, boxH: number): Thumb {
		const MAX_CELULAS_POR_EIXO = 60
		const scale = Math.min(boxW / page.w, boxH / page.h)
		const cells: { style: EstiloCss }[] = []
		const rows = Math.min(grid.rows, MAX_CELULAS_POR_EIXO)
		const cols = Math.min(grid.cols, MAX_CELULAS_POR_EIXO)
		for (let r = 0; r < rows; r++) {
			for (let c = 0; c < cols; c++) {
				const lx = grid.marginX + c * (label.w + grid.gapX)
				const ly = grid.marginY + r * (label.h + grid.gapY)
				cells.push({ style: {
					position: 'absolute', left: (lx * scale) + 'px', top: (ly * scale) + 'px',
					width: Math.max(1, label.w * scale) + 'px', height: Math.max(1, label.h * scale) + 'px',
				} })
			}
		}
		return { cells, boxStyle: {
			position: 'relative', width: (page.w * scale) + 'px', height: (page.h * scale) + 'px',
			background: '#fff', border: '1px solid #E0E0E0', flex: '0 0 auto', overflow: 'hidden',
		} }
	}

	montarModeloView(m: ModeloDeEtiqueta): ModeloView {
		const t = m.tamanho
		const label = { w: t ? Number(t.larguraEtiqueta) || 0 : 0, h: t ? Number(t.alturaEtiqueta) || 0 : 0 }
		const bobina = { w: t ? Number(t.larguraPagina) || 0 : 0, h: t ? Number(t.alturaPagina) || 0 : 0 }
		const grade: DimensaoComGrade = {
			bobina, w: label.w, h: label.h,
			gap: t ? Number(t.distanciaEntreEtiquetas) || 0 : 0,
			marginX: t ? Number(t.bordaEsquerda) || 0 : 0,
			marginY: t ? Number(t.bordaDoTopo) || 0 : 0,
		}
		const impressaoUnica = !!(t && t.impressaoUnica)
		const cols = impressaoUnica ? 1 : this.computeCols(grade)
		const rows = impressaoUnica ? 1 : this.computeRows(grade)
		const paginaValida = !impressaoUnica && bobina.w > 0 && bobina.h > 0
		const pagina = paginaValida ? bobina : { w: label.w || 1, h: label.h || 1 }
		const tamanhoThumb = this.buildThumb(pagina, label, {
			cols, rows, gapX: grade.gap, gapY: grade.gap,
			marginX: paginaValida ? grade.marginX : 0, marginY: paginaValida ? grade.marginY : 0,
		}, 40, 52)
		return {
			id: m.id,
			nome: m.descricao,
			grupoEconomico: m.grupoEconomico ? m.grupoEconomico.descricao : '—',
			dimensoes: label.w + ' × ' + label.h + ' cm',
			tamanhoNome: t ? t.descricao : 'Personalizado',
			tamanhoThumb,
			preview: this.montarPreviewDeCampos(label, m.campos, 58, 78),
			bigPreview: this.montarPreviewDeCampos(label, m.campos, 220, 280),
			original: m,
		}
	}

	montarPreviewDeCampos(label: Retangulo, campos: CampoDoModeloDeEtiqueta[], boxW: number, boxH: number): Preview {
		const larguraCm = label.w || 1
		const alturaCm = label.h || 1
		const scale = Math.min(boxW / larguraCm, boxH / alturaCm)
		const px = (n: number) => (Number(n) || 0) * scale
		const alinhamentoTexto: Record<TipoDeAlinhamentoDeTexto, string> = { ESQUERDA: 'left', CENTRO: 'center', DIREITA: 'right' }
		const justificarTexto: Record<TipoDeAlinhamentoDeTexto, string> = { ESQUERDA: 'flex-start', CENTRO: 'center', DIREITA: 'flex-end' }
		const els: ElementoPreview[] = (campos || []).map(campo => {
			const isBar = this.tipoDeDadoDoCampo(campo) === 'GRAFICO'
			const wrap: EstiloCss = {
				position: 'absolute', display: 'flex', alignItems: 'center',
				justifyContent: justificarTexto[campo.alinhamento] || 'flex-start',
				left: px(campo.x) + 'px', top: px(campo.y) + 'px',
				width: px(campo.largura) + 'px', height: px(campo.altura) + 'px',
				overflow: 'hidden',
			}
			const res: ElementoPreview = { isBarcode: isBar, wrapStyle: wrap }
			if (isBar) {
				res.barcodeStyle = { width: '100%', height: '100%',
					background: 'repeating-linear-gradient(90deg,#111 0px,#111 2px,transparent 2px,transparent 3px,'
						+ '#111 3px,#111 6px,transparent 6px,transparent 8px,#111 8px,#111 11px,transparent 11px,transparent 13px)' }
			} else {
				wrap.fontSize = Math.max(6, (Number(campo.tamanhoDaFonte) || 0) / this.PONTOS_POR_CM * scale) + 'px'
				wrap.fontWeight = campo.negrito ? '700' : '400'
				wrap.textAlign = alinhamentoTexto[campo.alinhamento] || 'left'
				wrap.color = '#212121'
				wrap.lineHeight = '1.05'
				res.contentStyle = { display: 'block', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }
				res.content = this.valorDeExemploDoCampo(campo)
			}
			return res
		})
		return { els, boxStyle: {
			position: 'relative', width: (larguraCm * scale) + 'px', height: (alturaCm * scale) + 'px',
			background: '#fff', border: '1px solid #E0E0E0', borderRadius: '2px', flex: '0 0 auto', overflow: 'hidden',
		} }
	}

	tipoDeDadoDoCampo(campo: CampoDoModeloDeEtiqueta): string {
		return this.camposDisponiveis.find(d => d.chave === campo.campo)?.tipoDeDado || 'TEXTO'
	}

	valorDeExemploDoCampo(campo: CampoDoModeloDeEtiqueta): string {
		if (campo.campo === 'PRECO_DA_TABELA') {
			return montarTextoDePrecoDaTabela(
				campo,
				EXEMPLO_NOME_DA_TABELA,
				this.valorDeExemploDoCatalogo('PRECO_DA_TABELA'),
				EXEMPLO_LIMITACAO,
			)
		}
		return this.valorDeExemploDoCatalogo(campo.campo)
	}

	valorDeExemploDoCatalogo(chave: CampoDeEtiqueta | null): string {
		return this.camposDisponiveis.find(d => d.chave === chave)?.valorDeExemplo || ''
	}

	openNovoTamanho() {
		if (!this.podeEditarTamanhoDeEtiqueta) return
		this.tamanhoEmEdicao = null
		this.modalTamanho = { id: null, nome: '', bobinaW: 0, bobinaH: 0, labelW: 0, labelH: 0, gap: 0, marginX: 0, marginY: 0, impressaoUnica: false }
		this.modalTamanhoOpen = true
		this.resetValidacaoModalTamanho()
	}

	openEditarTamanho(t: TamanhoDaEtiqueta) {
		if (!this.podeEditarTamanhoDeEtiqueta) return
		this.tamanhoEmEdicao = t
		this.modalTamanho = {
			id: t.id,
			nome: t.descricao,
			grupoEconomico: t.grupoEconomico ? t.grupoEconomico.descricao : '',
			bobinaW: Number(t.larguraPagina) || 0,
			bobinaH: Number(t.alturaPagina) || 0,
			labelW: Number(t.larguraEtiqueta) || 0,
			labelH: Number(t.alturaEtiqueta) || 0,
			gap: Number(t.distanciaEntreEtiquetas) || 0,
			marginX: Number(t.bordaEsquerda) || 0,
			marginY: Number(t.bordaDoTopo) || 0,
			impressaoUnica: !!t.impressaoUnica,
		}
		this.modalTamanhoOpen = true
		this.resetValidacaoModalTamanho()
	}

	resetValidacaoModalTamanho() {
		this.$nextTick(() => {
			if (this.formTamanho) this.formTamanho.resetValidation()
		})
	}

	editarModelo(m: ModeloView) {
		if (!this.podeEditarModeloDeEtiqueta) return
		this.dialogoDeEdicaoModeloDeEtiqueta.mostrar(m.original, true)
	}

	async salvarModalTamanho() {
		const d = this.modalTamanho
		if (!d) return
		if (this.formTamanho && !this.formTamanho.validate()) {
			AlertModule.setError('Verifique os campos destacados antes de salvar')
			return
		}

		try {
			this.salvandoTamanho = true
			const base: TamanhoDaEtiqueta = this.tamanhoEmEdicao
				? { ...this.tamanhoEmEdicao }
				: {
					id: '', descricao: '', grupoEconomico: this.filtroTamanhoGrupo, impressaoUnica: false,
					larguraPagina: 0, alturaPagina: 0, larguraEtiqueta: 0, alturaEtiqueta: 0,
					bordaEsquerda: 0, distanciaEntreEtiquetas: 0, bordaDoTopo: 0,
				}
			const tamanho: TamanhoDaEtiqueta = {
				...base,
				descricao: d.nome || base.descricao,
				impressaoUnica: !!d.impressaoUnica,
				larguraPagina: Number(d.bobinaW) || 0,
				alturaPagina: Number(d.bobinaH) || 0,
				larguraEtiqueta: Number(d.labelW) || 0,
				alturaEtiqueta: Number(d.labelH) || 0,
				distanciaEntreEtiquetas: Number(d.gap) || 0,
				bordaEsquerda: Number(d.marginX) || 0,
				bordaDoTopo: Number(d.marginY) || 0,
			}

			if (tamanho.id) {
				await this.etiquetaDePrecoService.updatetamanhoDaEtiqueta(tamanho.id, tamanho)
			} else {
				await this.etiquetaDePrecoService.createTamanhoDeEtiqueta(tamanho)
			}

			AlertModule.setSuccess('Tamanho de etiqueta salvo com sucesso')
			this.modalTamanhoOpen = false
			this.buscarTamanhos()
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvandoTamanho = false
		}
	}

	usarModelo(m: ModeloView) {
		this.modeloSelecionadoId = this.modeloSelecionadoId === m.id ? null : m.id
	}

	async excluirModelo(m: ModeloView) {
		if (!this.podeEditarModeloDeEtiqueta) return
		try {
			await this.modeloDeEtiquetaUseCase.deleteModeloDeEtiqueta(m.id)
			if (this.modeloSelecionadoId === m.id) this.modeloSelecionadoId = null
			this.buscarModelos()
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	async incluirProduto() {
		if (!this.produtoSelecionado) return
		if (!this.quantidade) return
		if (!this.loja) {
			AlertModule.setError('Necessário selecionar uma loja!')
			return
		}

		const item: FormEtiquetaDePreco = {
			layout: null,
			idTabelas: null,
			produtoId: this.produtoSelecionado.id,
			sku: '',
			ean: this.produtoSelecionado.eans?.[0] || '',
			nomeDoProduto: displayNomeCompletoDoProduto(this.produtoSelecionado),
			quantidade: this.quantidade,
			lojaId: this.loja.id,
			tamanho: null,
		}

		this.itensBipados.push(item)
		this.$set(this.produtosBipados, this.produtoSelecionado.id, this.produtoSelecionado)

		this.quantidade = 1
		this.produtoSelecionado = null
		this.busca = null
		setTimeout(() => {
			if (this.campoDeBuscaDoProduto) this.campoDeBuscaDoProduto.focus()
		})
	}

	async buscarProdutosPorNota() {
		if (!this.filtrosNota.numeroNota || !this.filtrosNota.serie) {
			AlertModule.setError('Digite a serie da NFe e o número da nota')
			return
		}
		if (!this.loja) {
			AlertModule.setError('Necessário selecionar uma Loja')
			return
		}
		if (!this.fornecedor) {
			AlertModule.setError('Necessário selecionar o emitente da nota')
			return
		}

		try {
			this.carregandoProdutosNota = true
			const params = { serie: this.filtrosNota.serie, numero: this.filtrosNota.numeroNota }
			const produtosParaImpressao: any = await this.etiquetaDePrecoService.findProdutosNotaBySerieAndNnf(
				params, this.loja.id, this.fornecedor.id,
			)
			if (Array.isArray(produtosParaImpressao)) {
				produtosParaImpressao.forEach((formProduto: any) => {
					this.itensBipados.push({
						layout: null,
						idTabelas: null,
						produtoId: formProduto.produtoId,
						sku: formProduto.sku,
						ean: formProduto.ean || '',
						nomeDoProduto: formProduto.nomeDoProduto,
						quantidade: formProduto.quantidade || 1,
						lojaId: this.loja ? this.loja.id : formProduto.lojaId,
						tamanho: null,
					})
				})
			}

			if (Array.isArray(produtosParaImpressao) && produtosParaImpressao.length >= 1) {
				this.notasBuscadas = true
			} else {
				AlertModule.setError('Nenhuma nota encontrada para o filtro selecionado')
			}
		} catch (error: any) {
			AlertModule.setError('Erro ao buscar produtos da nota: ' + error.message)
		} finally {
			this.carregandoProdutosNota = false
		}
	}

	limparProdutos() {
		this.itensBipados = []
		this.produtosBipados = {}
		this.notasBuscadas = false
		this.fornecedor = null
		this.filtrosNota = { numeroNota: '', serie: '' }
		this.produtoSelecionado = null
		this.quantidade = 1
		this.busca = null
		localStorage.removeItem(ITENS_BIPADOS_MODELO)
	}

	@Watch('itensBipados', { deep: true })
	@Watch('produtosBipados', { deep: true })
	onChangeItensBipados() {
		localStorage.setItem(ITENS_BIPADOS_MODELO, JSON.stringify({
			itensBipados: this.itensBipados,
			produtosBipados: this.produtosBipados,
		}))
	}

	removerItem(index: number) {
		this.itensBipados.splice(index, 1)
	}

	// Compartilhada entre prévia e impressão: as duas precisam exatamente das mesmas informações
	// resolvidas, e checagem duplicada é onde uma das duas fica para trás na próxima alteração.
	private validarAntesDeEmitir(): boolean {
		if (!this.modeloSelecionadoId) {
			AlertModule.setError('Necessário selecionar um modelo de etiqueta para imprimir')
			return false
		}
		if (!this.loja) {
			AlertModule.setError('Necessário selecionar uma loja')
			return false
		}
		if (this.modeloRequerTabelaDePreco && this.tabelasSelecionadas.length === 0) {
			AlertModule.setError('Este modelo usa campos de preço/plano: selecione ao menos uma tabela de preço para imprimir')
			return false
		}
		// Só cobra escolha quando existe escolha a fazer.
		if (this.precisaEscolherEstacao && !this.estacaoSelecionadaId) {
			AlertModule.setError('Esta loja tem mais de uma impressora: selecione em qual quer imprimir')
			return false
		}
		return true
	}

	// Só pode ser chamada depois de validarAntesDeEmitir() passar — é ela que garante modelo e loja
	// preenchidos. As asserções aqui documentam esse contrato: inline, o TypeScript estreitava o tipo
	// sozinho pelas checagens; extraído, precisa ser dito.
	private montarEntradaDeImpressao(): EntradaDeImpressaoDeModeloDeEtiqueta {
		const idTabelas = this.modeloRequerTabelaDePreco ? this.tabelasSelecionadas.map(t => t.id) : []
		return {
			modeloId: this.modeloSelecionadoId as string,
			lojaId: (this.loja as Loja).id,
			itens: this.itensBipados.map(item => ({ produtoId: item.produtoId, quantidade: item.quantidade })),
			idTabelas,
			parcelasPorTabela: this.parcelasPorTabela,
		}
	}

	async imprimir() {
		if (!this.itensBipados.length) return
		if (!this.validarAntesDeEmitir()) return
		if (!this.validarEstacaoParaImpressao()) return

		const estacao = this.estacaoSelecionada
		if (!estacao) return

		try {
			this.imprimindo = true
			const resultado = await this.modeloDeEtiquetaUseCase.imprimirNaEstacao(
				estacao.id,
				this.montarEntradaDeImpressao(),
			)

			this.salvarNoHistorico(estacao)

			AlertModule.setSuccess(
				`Enviado para "${estacao.nome}": ${resultado.quantidadeDeEtiquetas} etiqueta(s) `
				+ `em ${resultado.totalDeFatias} parte(s). Acompanhe em "Impressões enviadas".`,
			)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.imprimindo = false
		}
	}

	async baixarArquivoParaBancada() {
		if (!this.itensBipados.length) return
		if (!this.validarAntesDeEmitir()) return
		if (!this.validarEstacaoParaImpressao()) return

		const estacao = this.estacaoSelecionada
		if (!estacao) return

		try {
			this.baixandoArquivo = true
			const fatias = await this.modeloDeEtiquetaUseCase.gerarImpressaoParaEstacao(
				estacao.id,
				this.montarEntradaDeImpressao(),
			)

			baixarConteudoDeImpressao(fatias, estacao)

			const totalDeEtiquetas = fatias.reduce((total, fatia) => total + fatia.quantidadeDeEtiquetas, 0)
			AlertModule.setSuccess(
				`${estacao.linguagem} gerado para "${estacao.nome}": ${totalDeEtiquetas} etiqueta(s) `
				+ `em ${fatias.length} fatia(s). O arquivo não passa pela fila — use para testar na impressora.`,
			)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.baixandoArquivo = false
		}
	}

	// A prévia em PDF não depende de estação; a impressão direta sim, é ela que diz para qual
	// impressora e em que linguagem/DPI gerar.
	private validarEstacaoParaImpressao(): boolean {
		if (!this.estacoesDaLoja.length) {
			// Separa "não conseguiu consultar" de "não existe cadastro": mandar alguém acionar o
			// suporte por causa de uma falha momentânea de rede é desperdício dos dois lados.
			AlertModule.setError(
				this.falhouAoCarregarEstacoes
					? 'Não foi possível consultar as impressoras desta loja. Tente novamente em instantes.'
					: 'Esta loja não tem estação de impressora configurada e ativa. '
						+ 'Acione o suporte para configurar a impressora antes de imprimir.',
			)
			return false
		}
		if (!this.estacaoSelecionada) {
			AlertModule.setError('Selecione em qual impressora quer imprimir')
			return false
		}
		return true
	}

	private salvarNoHistorico(estacao: EstacaoDeImpressao) {
		DialogoDeHistoricoDeEmissaoDeEtiqueta.salvar({
			id: Date.now().toString(),
			dataHora: new Date().toISOString(),
			lojaId: (this.loja as Loja).id,
			lojaNome: (this.loja as Loja).nomeFantasia || '',
			modeloId: this.modeloSelecionadoId as string,
			modeloDescricao: this.modeloSelecionadoLabel,
			estacaoId: estacao.id,
			estacaoNome: estacao.nome,
			idTabelas: this.modeloRequerTabelaDePreco ? this.tabelasSelecionadas.map(t => t.id) : [],
			parcelasPorTabela: { ...this.parcelasPorTabela },
			itens: this.itensBipados.map(item => ({
				produtoId: item.produtoId,
				sku: item.sku,
				ean: item.ean,
				nomeDoProduto: item.nomeDoProduto,
				quantidade: item.quantidade,
			})),
		})
	}

	abrirHistoricoDeEmissao() {
		this.dialogoDeHistoricoDeEmissao.mostrar()
	}

	async reimprimirDoHistorico(item: HistoricoDeEmissaoDeEtiqueta) {
		if (!item.estacaoId) {
			AlertModule.setError(
				'Esta impressão foi registrada sem impressora e não pode ser repetida. Selecione a impressora e imprima novamente.',
			)
			this.dialogoDeHistoricoDeEmissao.setCarregando(null)
			return
		}
		try {
			const resultado = await this.modeloDeEtiquetaUseCase.imprimirNaEstacao(item.estacaoId, {
				modeloId: item.modeloId,
				lojaId: item.lojaId,
				itens: item.itens.map(produto => ({ produtoId: produto.produtoId, quantidade: produto.quantidade })),
				idTabelas: item.idTabelas,
				parcelasPorTabela: item.parcelasPorTabela,
			})

			AlertModule.setSuccess(
				`Reenviado para "${item.estacaoNome}": ${resultado.quantidadeDeEtiquetas} etiqueta(s) `
				+ `em ${resultado.totalDeFatias} parte(s).`,
			)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.dialogoDeHistoricoDeEmissao.setCarregando(null)
		}
	}

	abrirHistoricoDeImpressao() {
		if (!this.loja) return
		this.dialogoDeHistoricoDeImpressao.mostrar((this.loja as Loja).id, this.estacoesDaLoja)
	}

	async visualizarPreviaEmPdf() {
		if (!this.itensBipados.length) return
		if (!this.validarAntesDeEmitir()) return

		const entrada = this.montarEntradaDeImpressao()

		try {
			this.carregandoPreviaPdf = true

			const conteudo = await this.modeloDeEtiquetaUseCase.previaDeConteudoDeEtiqueta(entrada)
			// eslint-disable-next-line no-console
			console.table(conteudo.paginas[0]?.map(el => ({
				conteudo: el.conteudo,
				x: el.x.toFixed(2),
				y: el.y.toFixed(2),
				largura: el.largura.toFixed(2),
				altura: el.altura.toFixed(2),
				alinhamento: el.alinhamento,
			})))

			const pdf = await this.modeloDeEtiquetaUseCase.previaDeEtiquetaEmPdf(entrada)
			abrirPreviaDeEtiquetaEmPdf(pdf)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregandoPreviaPdf = false
		}
	}

	abrirDialogoDeEdicaoModeloDeEtiqueta() {
		if (!this.podeEditarModeloDeEtiqueta) return
		const novo: ModeloDeEtiqueta = {
			id: '',
			descricao: '',
			grupoEconomico: this.filtroModeloGrupo || null,
			tamanho: null,
			campos: [],
		}
		this.dialogoDeEdicaoModeloDeEtiqueta.mostrar(novo, false)
	}

	onModeloSalvo() {
		this.buscarModelos()
	}

}

function abrirPreviaDeEtiquetaEmPdf(pdf: ArrayBuffer): void {
	const url = window.URL.createObjectURL(new Blob([pdf], { type: 'application/pdf' }))
	window.open(url, '_blank')
}

// UTF-8 explícito no Blob porque é o charset em que o backend gerou o conteúdo: o ZPL declara ^CI28,
// o TSPL declara CODEPAGE UTF-8, e o EPL — que não tem UTF-8 — já vem sem acento do backend, então
// nos três casos os bytes do arquivo são os mesmos que a impressora vai receber pela fila.
// A extensão segue a linguagem da estação só para o arquivo se identificar na bancada.
function baixarConteudoDeImpressao(fatias: FatiaDeImpressaoDeEtiquetas[], estacao: EstacaoDeImpressao): void {
	const conteudo = fatias
		.flatMap(fatia => fatia.unidades.map(unidade => unidade.conteudo))
		.join('')

	const url = window.URL.createObjectURL(new Blob([conteudo], { type: 'text/plain;charset=utf-8' }))
	const link = document.createElement('a')
	link.href = url
	link.download = `etiquetas-${estacao.nome.replace(/[^A-Za-z0-9-_]+/g, '-').toLowerCase()}`
		+ `.${extensaoDeArquivoDaLinguagem(estacao.linguagem)}`
	link.click()
	window.URL.revokeObjectURL(url)
}

